<template>
    <div class="flex">
        <div v-if="cash !== null" class="flex items-center">
            <i
                class="tooltip mdi mdi-cash text-xl mr-1 settings-icon"
                :class="cash ? 'enabled' : 'disabled'"
            >
                <span class="tooltip-text text-sm">{{getTooltip('cash')}}</span>
            </i>
        </div>
        <div v-if="card !== null" class="flex items-center text-grey">
            <i
                class="tooltip mdi mdi-credit-card text-xl mr-1 settings-icon"
                :class="card ? 'enabled' : 'disabled'"
            >
                <span class="tooltip-text text-sm">{{getTooltip('card')}}</span>
            </i>
        </div>
        <div v-if="accessible !== null" class="flex items-center text-grey">
            <i
                class="tooltip mdi mdi-wheelchair-accessibility text-xl mr-1 settings-icon"
                :class="accessible ? 'enabled' : 'disabled'"
            >
                <span class="tooltip-text text-sm">{{getTooltip('accessible')}}</span>
            </i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        accessible: {
            type: Boolean,
            default: false
        },
        card: {
            type: Boolean,
            default: false
        },
        cash: {
            type: Boolean,
            default: false
        },
    },

    methods: {
        getTooltip(prop) {
            if (!this[prop]) {
                return this.$t(`Office_${prop}_disabled`)
            } else {
                return this.$t(`Office_${prop}`)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.settings-icon {
    font-size: 1.4rem;
}

.enabled {
    color: #2196F3;
}

.disabled {
    color: #E3342F;
}
</style>


// WEBPACK FOOTER //
// src/components/Patient/OfficeSettings.vue